import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AvailableDates() {
  const [months, setMonths] = useState([]);
  useEffect(() => {
    api.get("/available-dates").then(({ data }) => setMonths(data)).catch(() => {});
  }, []);

  if (months.length === 0) return null;

  return (
    <section className="px-6 sm:px-10 py-24 border-t border-[#E8E1DA] bg-[#FAFAFA]" data-testid="available-dates">
      <div className="max-w-5xl mx-auto">
        <p className="overline text-[#8B6D5E] mb-3">— Agenda</p>
        <h2 className="font-serif text-4xl sm:text-5xl mb-3 leading-tight">
          Disponibilidad próxima.
        </h2>
        <p className="font-serif italic text-2xl sm:text-3xl text-[#8B6D5E] mb-12">
          Reserva con anticipación.
        </p>
        <div className="grid md:grid-cols-3 gap-3">
          {months.map((m) => (
            <div key={m.month_key} className="p-8 border border-[#E8E1DA] bg-white" data-testid={`month-${m.month_key}`}>
              <p className="overline text-[#8B6D5E] mb-3">{m.month_label}</p>
              {m.is_open ? (
                <>
                  <p className="font-serif text-4xl mb-2">
                    {m.available}
                  </p>
                  <p className="text-sm text-[#5C5C5C]">
                    fecha{m.available === 1 ? "" : "s"} disponible{m.available === 1 ? "" : "s"}
                  </p>
                </>
              ) : (
                <>
                  <p className="font-serif text-2xl mb-2 text-[#8B6D5E]">Completo</p>
                  <p className="text-sm text-[#5C5C5C]">Waitlist abierta</p>
                </>
              )}
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-[#5C5C5C] max-w-2xl">
          Cifras actualizadas semanalmente. Novias con fecha entre 60 y 180 días
          antes del evento tienen prioridad de reserva.
        </p>
      </div>
    </section>
  );
}
